const COMMENTS = [
  {
    name: '影迷小陈',
    time: '2天前',
    avatar: 'C',
    content: '自从发现了麻花影视，追剧再也不用到处找资源了。片库真的太全了，飘花电影网和555电影的资源这里都有，而且播放很流畅，强烈推荐！',
    likes: 326,
  },
  {
    name: '追剧达人',
    time: '3天前',
    avatar: '追',
    content: '《大江大河3》更新当天就能在这里看到，速度真的快。画质也很清晰，用平板看体验特别好。8090电影网的经典老片也收录了很多，怀旧党狂喜。',
    likes: 218,
  },
  {
    name: '电影发烧友',
    time: '5天前',
    avatar: '电',
    content: '作为一个每周看5部电影的人，麻花影视的专题索引功能帮我省了很多时间，按类型找片太方便了。暑期档的热门大片基本都有，还不用等广告，良心网站。',
    likes: 187,
  },
  {
    name: '周末影院',
    time: '6天前',
    avatar: '周',
    content: '免费不用注册这点真的很棒，给家里老人用也方便。片源更新快，清晰度高，最重要的是真的不缓冲！推荐给身边好多朋友了，都说好用。',
    likes: 142,
  },
];

export default function SectionComments() {
  return (
    <section id="comments" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
            用户心声
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            来自真实用户的观影体验分享
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {COMMENTS.map((comment) => (
            <div
              key={comment.name}
              className="p-5 rounded-xl bg-background-100 border border-background-300/40"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-500/20 flex items-center justify-center shrink-0">
                  <span className="text-sm font-bold text-primary-400">
                    {comment.avatar}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-200">
                    {comment.name}
                  </div>
                  <div className="text-xs text-foreground-600">{comment.time}</div>
                </div>
                <div className="flex items-center gap-1 text-foreground-500 shrink-0">
                  <i className="ri-thumb-up-line text-xs"></i>
                  <span className="text-xs">{comment.likes}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">
                {comment.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}